import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './CookieConsent.css';

const COOKIE_CONSENT_KEY = 'loopy_cookie_consent';

const CookieConsent: React.FC = () => {
  const { t } = useTranslation('home');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const hasConsented = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!hasConsented) {
      // Small delay to prevent flash on page load
      const timer = setTimeout(() => setIsVisible(true), 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-consent__content">
        <div className="cookie-consent__icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <circle cx="8" cy="9" r="1" fill="currentColor"/>
            <circle cx="15" cy="8" r="1" fill="currentColor"/>
            <circle cx="10" cy="14" r="1" fill="currentColor"/>
            <circle cx="16" cy="13" r="1" fill="currentColor"/>
            <circle cx="12" cy="17" r="1" fill="currentColor"/>
          </svg>
        </div>
        <div className="cookie-consent__text">
          <p>{t('cookieConsent.message')}</p>
          <p className="cookie-consent__links">
            <Link to="/privacy">{t('cookieConsent.privacyPolicy')}</Link>
            <span className="cookie-consent__separator">|</span>
            <Link to="/terms">{t('cookieConsent.terms')}</Link>
          </p>
        </div>
        <div className="cookie-consent__actions">
          <button
            className="cookie-consent__btn cookie-consent__btn--accept"
            onClick={handleAccept}
          >
            {t('cookieConsent.accept')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
